import { render, staticRenderFns } from "./Gsb.vue?vue&type=template&id=aedd2ae2&"
import script from "./Gsb.vue?vue&type=script&lang=js&"
export * from "./Gsb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports